import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import aboutES from './locales/es/about.json';
import aboutEN from './locales/en/about.json';

import translationES from './locales/es/translation.json';
import translationEN from './locales/en/translation.json';

//seccion habitaciones
import roomsES from './locales/es/rooms.json';
import roomsEN from './locales/en/rooms.json';

// seccion prensa
import pressES from './locales/es/press.json';
import pressEN from './locales/en/press.json';

//seccion nuestros servicios
import servicesES from './locales/es/services.json';
import servicesEN from './locales/en/services.json';

//  seccion 6 razones
import reasonsES from './locales/es/reasons.json';
import reasonsEN from './locales/en/reasons.json';

//  seccion testimonios
import testimonialsES from './locales/es/testimonials.json';
import testimonialsEN from './locales/en/testimonials.json';

// seccion instagram
import instagramES from './locales/es/instagram.json';
import instagramEN from './locales/en/instagram.json';

// livefeed
import livefeedES from './locales/es/livefeed.json';
import livefeedEN from './locales/en/livefeed.json';

// Footer
import footerES from './locales/es/footer.json';
import footerEN from './locales/en/footer.json';

// Galeria
import galleryES from './locales/es/gallery.json';
import galleryEN from './locales/en/gallery.json';

//Prensa
import pressPageES from './locales/es/pressPage.json';
import pressPageEN from './locales/en/pressPage.json';

// Ubicacion
import locationES from './locales/es/location.json';
import locationEN from './locales/en/location.json';

// Tips
import tipsES from './locales/es/tips.json';
import tipsEN from './locales/en/tips.json';

// Tours
import toursPageES from './locales/es/toursPage.json';
import toursPageEN from './locales/en/toursPage.json';

// Contacto
import contactPageES from './locales/es/contactPage.json';
import contactPageEN from './locales/en/contactPage.json';

// FAQ
import faqPageES from './locales/es/faqPage.json';
import faqPageEN from './locales/en/faqPage.json';

// Restaurante mangle
import restaurantMangleES from './locales/es/restaurantMangle.json';
import restaurantMangleEN from './locales/en/restaurantMangle.json';

// Traslados
import transfersPageES from './locales/es/transfersPage.json';
import transfersPageEN from './locales/en/transfersPage.json';

// Cenas Romanticas
import romanticDinnersPageES from './locales/es/romanticDinnersPage.json';
import romanticDinnersPageEN from './locales/en/romanticDinnersPage.json';

// Propuestas de matrimonio
import marriageProposalsPageES from './locales/es/marriageProposalsPage.json';
import marriageProposalsPageEN from './locales/en/marriageProposalsPage.json';

// Wellness
import wellnessPageES from './locales/es/wellnessPage.json';
import wellnessPageEN from './locales/en/wellnessPage.json';

// Bodas
import weddingsPageES from './locales/es/weddingsPage.json';
import weddingsPageEN from './locales/en/weddingsPage.json';

// Seccion Otras Habitaciones
import otherRoomsES from './locales/es/otherRooms.json';
import otherRoomsEN from './locales/en/otherRooms.json';

// Seccion Compara Habitaciones
import compareRoomsES from './locales/es/compareRooms.json';
import compareRoomsEN from './locales/en/compareRooms.json';

// Menu
import mobileMenuES from './locales/es/mobileMenu.json';
import mobileMenuEN from './locales/en/mobileMenu.json';

// Navbar
import navbarES from './locales/es/navbar.json';
import navbarEN from './locales/en/navbar.json';

// -------- HABITACIONES ----------- //

//Vista al mar
import vistaMarPageES from './locales/es/vistaMarPage.json';
import vistaMarPageEN from './locales/en/vistaMarPage.json';

// Bungalow Jardin
import bungalowJardinPageES from './locales/es/bungalowJardinPage.json';
import bungalowJardinPageEN from './locales/en/bungalowJardinPage.json';

// Bungalow Arena
import bungalowArenaPageES from './locales/es/bungalowArenaPage.json';
import bungalowArenaPageEN from './locales/en/bungalowArenaPage.json';

// -------- BOTONES ----------//

// Boton de Contacto
import buttonsES from './locales/es/buttons.json';
import buttonsEN from './locales/en/buttons.json';

// Employe Page
import employePageES from './locales/es/employePage.json';
import employePageEN from './locales/en/employePage.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: translationES,
        about: aboutES,
        rooms: roomsES,   
        press: pressES,
        services: servicesES,
        reasons: reasonsES,
        testimonials: testimonialsES,
        instagram: instagramES,
        livefeed: livefeedES,
        footer: footerES,
        gallery: galleryES,
        pressPage: pressPageES,
        location: locationES,
        tips: tipsES,
        toursPage: toursPageES,
        contactPage: contactPageES,
        faqPage: faqPageES,
        restaurantMangle: restaurantMangleES,
        transfersPage: transfersPageES,
        romanticDinnersPage: romanticDinnersPageES,
        marriageProposalsPage: marriageProposalsPageES,
        wellnessPage: wellnessPageES,
        weddingsPage: weddingsPageES,
        vistaMarPage: vistaMarPageES,
        bungalowJardinPage: bungalowJardinPageES,
        bungalowArenaPage: bungalowArenaPageES,
        otherRooms: otherRoomsES,
        compareRooms: compareRoomsES,
        buttons: buttonsES,
        mobileMenu: mobileMenuES,
        navbar: navbarES,
        employePage: employePageES
      },
      en: {
        translation: translationEN,
        about: aboutEN,
        rooms: roomsEN,   
        press: pressEN,
        services: servicesEN,
        reasons: reasonsEN,
        testimonials: testimonialsEN,
        instagram: instagramEN,
        livefeed: livefeedEN,
        footer: footerEN,
        gallery: galleryEN,
        pressPage: pressPageEN,
        location: locationEN,
        tips: tipsEN,
        toursPage: toursPageEN,
        contactPage: contactPageEN,
        faqPage: faqPageEN,
        restaurantMangle: restaurantMangleEN,
        transfersPage: transfersPageEN,
        romanticDinnersPage: romanticDinnersPageEN,
        marriageProposalsPage: marriageProposalsPageEN,
        wellnessPage: wellnessPageEN,
        weddingsPage: weddingsPageEN,
        vistaMarPage: vistaMarPageEN,
        bungalowJardinPage: bungalowJardinPageEN,
        bungalowArenaPage: bungalowArenaPageEN,
        otherRooms: otherRoomsEN,
        compareRooms: compareRoomsEN,
        buttons: buttonsEN,
        mobileMenu: mobileMenuEN,
        navbar: navbarEN,
        employePage: employePageEN

      },
    },
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
